import { jsx as p } from "react/jsx-runtime";
import { twJoin as h } from "tailwind-merge";
import { semanticOrder as d } from "./toolbar-semantic-order.mjs";
const s = ({
  extension: o,
  source: n,
  skipRef: l,
  withRightBorder: a,
  inTooltip: e
}) => {
  const t = n.filter((r) => r.key === o);
  return t.length ? t.map((r, f) => /* @__PURE__ */ p(
    "div",
    {
      ref: l ? void 0 : r.ref,
      className: h(
        f === t.length - 1 && a && "border-r border-text-secondary/30 last-of-type:border-r-0",
        "flex items-center",
        !e && "px-px first-of-type:pl-0 last-of-type:pr-0"
      ),
      children: e ? r.toolbarItem.tooltipRender : r.toolbarItem.toolbarRender
    },
    `${r.key}-${f}`
  )) : null;
}, b = ({
  source: o,
  skipBorder: n,
  skipRef: l,
  inTooltip: a
}) => d.flatMap((e, t) => {
  const r = t === d.length - 1;
  return Array.isArray(e) ? e.flatMap((f, i) => s({
    extension: f,
    source: o,
    skipRef: l,
    withRightBorder: !n && !r && i === e.length - 1,
    inTooltip: a
  })) : s({
    extension: e,
    source: o,
    skipRef: l,
    withRightBorder: !n && !r,
    inTooltip: a
  });
});
export {
  b as renderInSemanticOrder
};
